module.exports = __webpack_public_path__ + "static/bkg-blur-1f21c67f58bf838bda2f8e0767c95b1c.png";